var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BasicInfo'),_c('ContactInfo',{staticClass:"mt-3"}),_c('PlacesLived',{staticClass:"mt-3"}),_c('WebAndSocials',{staticClass:"mt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }